export default {"src":"/_next/static/media/DownloadButton.9843ac98.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};